// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

const getLastDismissedRatingUuid = (state: ReduxStateShared) => state.rateShipment.lastDismissedRatingUuid;

export default getLastDismissedRatingUuid;
